/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sellers_Logoalt1Inputs */

const id_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const ms_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const da_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} logo`)
};

const de_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Logo`)
};

const en_us2_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} logo`)
};

const es_es2_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo de ${i?.name}`)
};

const es_mx2_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo de ${i?.name}`)
};

const fil_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ni ${i?.name}`)
};

const fr_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const it_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const hu_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} logó`)
};

const nl_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} logo`)
};

const no_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-logo`)
};

const pl_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const pt_br2_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logotipo ${i?.name}`)
};

const pt_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logótipo ${i?.name}`)
};

const ro_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const fi_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-logo`)
};

const sv_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-logotyp`)
};

const vi_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const tr_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} logosu`)
};

const cs_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo ${i?.name}`)
};

const bg_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Лого на ${i?.name}`)
};

const ru_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Логотип ${i?.name}`)
};

const uk_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Логотип ${i?.name}`)
};

const ar_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`شعار ${i?.name}`)
};

const hi_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} लोगो`)
};

const th_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`โลโก้ ${i?.name}`)
};

const ja_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ロゴ`)
};

const zh_cn2_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Logo`)
};

const zh_hant1_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Logo`)
};

const ko_sellers_logoalt1 = /** @type {(inputs: Sellers_Logoalt1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 로고`)
};

/**
* | output |
* | --- |
* | "{name} logo" |
*
* @param {Sellers_Logoalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_logoalt1 = /** @type {((inputs: Sellers_Logoalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Logoalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_logoalt1(inputs)
	if (locale === "ms") return ms_sellers_logoalt1(inputs)
	if (locale === "da") return da_sellers_logoalt1(inputs)
	if (locale === "de") return de_sellers_logoalt1(inputs)
	if (locale === "en-US") return en_us2_sellers_logoalt1(inputs)
	if (locale === "es-ES") return es_es2_sellers_logoalt1(inputs)
	if (locale === "es-MX") return es_mx2_sellers_logoalt1(inputs)
	if (locale === "fil") return fil_sellers_logoalt1(inputs)
	if (locale === "fr") return fr_sellers_logoalt1(inputs)
	if (locale === "it") return it_sellers_logoalt1(inputs)
	if (locale === "hu") return hu_sellers_logoalt1(inputs)
	if (locale === "nl") return nl_sellers_logoalt1(inputs)
	if (locale === "no") return no_sellers_logoalt1(inputs)
	if (locale === "pl") return pl_sellers_logoalt1(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_logoalt1(inputs)
	if (locale === "pt") return pt_sellers_logoalt1(inputs)
	if (locale === "ro") return ro_sellers_logoalt1(inputs)
	if (locale === "fi") return fi_sellers_logoalt1(inputs)
	if (locale === "sv") return sv_sellers_logoalt1(inputs)
	if (locale === "vi") return vi_sellers_logoalt1(inputs)
	if (locale === "tr") return tr_sellers_logoalt1(inputs)
	if (locale === "cs") return cs_sellers_logoalt1(inputs)
	if (locale === "bg") return bg_sellers_logoalt1(inputs)
	if (locale === "ru") return ru_sellers_logoalt1(inputs)
	if (locale === "uk") return uk_sellers_logoalt1(inputs)
	if (locale === "ar") return ar_sellers_logoalt1(inputs)
	if (locale === "hi") return hi_sellers_logoalt1(inputs)
	if (locale === "th") return th_sellers_logoalt1(inputs)
	if (locale === "ja") return ja_sellers_logoalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_logoalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_logoalt1(inputs)
	return ko_sellers_logoalt1(inputs)
});
export { sellers_logoalt1 as "sellers.logoAlt" }